/**
* @params data: cdn地址返回的结果
* @return 展示的banner列表
*/
export const getIMCList = (data) => {
  // 获取0点时间戳
  const dataKey = Object.keys(data)[0]
  const originList = data[dataKey]
  const finalList = []
  const backData = Array.isArray(originList) ? originList.shift() : [] // 兜底数据
  const todayTime = getTime(new Date(), true) + 10 // 获取当天0点0.01秒时间戳
  // 筛选当天要展示的素材
  Array.isArray(originList) && originList.forEach(item => {
    if (!item) return
    const sDate = item.imc_start_time.replace(new RegExp(/-/gm), '/')
    const eDate = item.imc_end_time.replace(new RegExp(/-/gm), '/')
    const startTime = getTime(new Date(sDate), true) // 排期开始时间当天0点
    const endTime = getTime(new Date(eDate), false) // 排期结束时间当天23：59：59
    if (todayTime >= startTime && todayTime <= endTime) {
      finalList.push(item)
    }
  })
  // 按优先级排序
  finalList.sort((pre, next) => next.imc_priority - pre.imc_priority)
  // 如果不存在排期素材，则展示兜底素材
  if (!finalList.length && backData && backData.img) {
    finalList.push(backData)
  }
  return finalList
}

// 获取时间戳,type为true表示是0点,false还是23:59:59
function getTime (data, type) {
  const endtime = type ? ' 00:00:00' : ' 23:59:59'
  const today = data.getFullYear() + '/' + (data.getMonth() + 1) + '/' + data.getDate() + endtime
  return new Date(today).getTime()
}
